import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AvatarState } from 'src/interfaces/store.types';
import type { RootState } from 'src/store';
import { useAppSelector } from 'src/store/redux';

const initialState: AvatarState = {
  bigAvatarConfig: null,
  smallAvatarConfig: null,
  teacherAvatarConfig: null,
  msStudentAvatarConfig: null,
};

type ActionPayload = {
  configType: keyof AvatarState;
  avatarConfig: unknown;
};

export const avatarSlice = createSlice({
  name: 'avatar',
  initialState,
  reducers: {
    saveAvatarConfig: (state, action: PayloadAction<ActionPayload>) => {
      state[action.payload.configType] = action.payload.avatarConfig;
    },
  },
});

export const { saveAvatarConfig } = avatarSlice.actions;

export const useAvatarConfigSelector = () =>
  useAppSelector((state: RootState) => state.avatar);
export default avatarSlice.reducer;
